const initialState = {
    status : "ALL",
    colors : []
}

export default initialState;